import { defineAction } from '~/prix'
import { z } from 'zod'
import creditSoldProductDeleteAction from './creditSoldProductDelete.action.json' with { type: 'json' }
import { creditSoldProductObject } from '../creditSoldProductObject'

const creditSoldProductDeleteDefinition = defineAction({
  ...creditSoldProductDeleteAction,

  input: z.object({ id: creditSoldProductObject.shape.id }),
  output: z.object({}),
})

export default creditSoldProductDeleteDefinition

